/*
 * @Description: In User Settings Edit
 * @Author: 田付山
 * @Date: 2019-08-19 11:52:03
 * @LastEditTime: 2019-09-30 11:39:07
 * @LastEditors: Please set LastEditors
 */

import cache from '@/utils/cache'

// 带有缓存的 cachedSearch 静态方法
// 在 search 中初始化
let cachedSearch = undefined

const state = {
  bindedStatus: {},
  // 查询结果缓存
  searchResult: {},

}
const getters = {
  get(state) {
    return state.bindedStatus
  }
}
const mutations = {
  pushCollects(state, target) {
    let data = Object.assign({}, state.bindedStatus, target);
    state.bindedStatus = data
    //console.log(state.bindedStatus)
  },
  clearById(state, target) {
    state.bindedStatus[target] = {}
  },
  deleteById(state, target) {
    let area = state.bindedStatus
    delete area[target]
  },

}
const actions = {
  initBind(context, target) {
    context.commit('pushCollects', target)
  },
  clearById(context, target) {
    context.commit('clearById', target)
  },
  deleteProp(context, target) {
    context.commit('deleteById', target)
  },
  /**
   * 向指定的 url 发送 get 请求
   * (封装该操作的原因是后续可能需要对这里加入缓存)
   * @param {string} url 目标网址
   * @example
   * this.$store.dispatch('search', {url:'localhost:8080/echo'}).then(console.log)
   *  
   */
  search(context, { url }) {
    if (!cachedSearch) {
      cachedSearch = cache.cachedPromise(
        url => context.dispatch('api/get', { url }, { root: true }),
        0 // 0：立即清除缓存
          //    同一时刻的多个请求将被合并为一个，但后续不受影响
          // 1000： 1 s 后清除缓存
          //    1 秒内的多个请求合并为一个，类似于节流
          // undefined： 永久缓存 
          //    所有请求合并为一个，后续不再需要发送请求
      )
    }

    return cachedSearch(url)
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
